import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";

// core components
import InfoValueCard from "components/card/InfoValueCard";

// actions
import mappingStats from "api/product/mappingStats";

ProductMappingStats.propTypes = {
    retailerId: PropTypes.number,
};

function ProductMappingStats({retailerId}) {
    const intl = useIntl();
    const [stats, setStats] = useState({
        valid: {products: 0, variations: 0},
        incomplete: {products: 0, variations: 0},
        unmapped: {products: 0, variations: 0}
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const params = retailerId ? `retailer.id=${retailerId}` : null;

        mappingStats(params).then((data) => {
            setStats(data);
        }).finally(() => setLoading(false));
    }, [retailerId]);

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '16px',
                marginTop: '24px'
            }}>
                <InfoValueCard
                    label={intl.formatMessage({id: "retailer.list.stats.valid.label"})}
                    value={intl.formatMessage({id: "retailer.list.stats.products"}, {count: stats.valid.products.toLocaleString('fr-FR')})}
                    subtext={intl.formatMessage({id: "retailer.list.stats.variations"}, {count: stats.valid.variations.toLocaleString('fr-FR')})}
                    labelColor="success"
                    loading={loading}
                    tooltipTitle={intl.formatMessage({id: "retailer.list.stats.valid.tooltipTitle"})}
                    tooltip={intl.formatMessage({id: "retailer.list.stats.valid.tooltip"})}
                />
                <InfoValueCard
                    label={intl.formatMessage({id: "retailer.list.stats.unmapped.label"})}
                    value={intl.formatMessage({id: "retailer.list.stats.products"}, {count: stats.unmapped.products.toLocaleString('fr-FR')})}
                    subtext={intl.formatMessage({id: "retailer.list.stats.variations"}, {count: stats.unmapped.variations.toLocaleString('fr-FR')})}
                    labelColor="error"
                    loading={loading}
                    tooltipTitle={intl.formatMessage({id: "retailer.list.stats.unmapped.tooltipTitle"})}
                    tooltip={intl.formatMessage({id: "retailer.list.stats.unmapped.tooltip"})}
                />
                <InfoValueCard
                    label={intl.formatMessage({id: "retailer.list.stats.incomplete.label"})}
                    value={intl.formatMessage({id: "retailer.list.stats.products"}, {count: stats.incomplete.products.toLocaleString('fr-FR')})}
                    subtext={intl.formatMessage({id: "retailer.list.stats.variations"}, {count: stats.incomplete.variations.toLocaleString('fr-FR')})}
                    labelColor="grey"
                    loading={loading}
                    tooltipTitle={intl.formatMessage({id: "retailer.list.stats.incomplete.tooltipTitle"})}
                    tooltip={intl.formatMessage({id: "retailer.list.stats.incomplete.tooltip"})}
                />

            </div>
        </div>
    );
}

export default ProductMappingStats;
